export default {
  delete:'are you sure you want to delete',
  archive:'are you sure you want to archive'
}
